export enum TABS_ID {
  SPOT = 'spot',
  CROSS = 'margin',
  ISOLATED = 'isolated',
}

export enum ORDER_TYPE_NAME {
  LIMIT = 'limit',
  MARKET = 'market',
  STOP_LIMIT = 'stop-limit',
}

export enum Type {
  BUY = 'buy',
  SELL = 'sell',
}

export enum MODAL_TYPE {
  BORROW_REPAY = 'borrow',
  TRANSFER = 'transfer',
}

export enum GET_TEXT {
  InfoRisk = 'At Margin Level ≤ 1.10, liquidation is triggered to repay the loan. Margin Level = Total Asset Value in the account / (Total Borrowed Amount + Unrepaid Interest)',
}
